const boxTypes = {
  fullFlex: {
    flex: 1,
  },
  fullFlexJustifyCenter: {
    flex: 1,
    justifyContent: 'center',
  },
  fullFlexAlignCenter: {
    flex: 1,
    alignItems: 'center',
  },
  fullFlexJustifyAlignCenter: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
}

export { boxTypes }
